import axios from '../axios';
import { apiPaths } from '../helper/apiPaths';
import { errMsg, errMsgNoData } from '../helper/functions';
import { ErrorResponseType } from '../types';
import { AnnualReviewRequest } from '../types/getAnnualReviewApiTypes';

const getAnnualReviewCode = import.meta.env.VITE_GET_ANNUAL_REVIEW;
const saveAnnualReviewCode = import.meta.env.VITE_SAVE_ANNUAL_REVIEW;
const updateAnnualReviewHrCode = import.meta.env.VITE_GET_ANNUAL_UPDATE_ANNUAL_REVIEW_HR;
const getAnnualReviewUserStatusCode = import.meta.env.VITE_SAVE_ANNUAL_REVIEW_USER_STATUS;

interface AnnualReviewResponse {
  data: unknown | null;
  error: ErrorResponseType | null;
}

export const getAnnualReview = async (
  cycleId: string,
  menteeId: string
): Promise<AnnualReviewResponse> => {
  try {
    const response = await axios.get(
      `${apiPaths.annualReview}/${cycleId}/${menteeId}?code=${getAnnualReviewCode}`
    );

    return {
      data: (response.data || null) as AnnualReviewResponse,
      error: response.data ? null : errMsgNoData(),
    };
  } catch (error) {
    return {
      data: null,
      error: errMsg(error),
    };
  }
};

export const saveAnnualReview = async (
  cycleId: string,
  menteeId: string,
  data: AnnualReviewRequest
): Promise<AnnualReviewResponse> => {
  try {
    const response = await axios.post(
      apiPaths.annualReview +
        '/' +
        cycleId +
        '/' +
        menteeId +
        '?code=' +
        saveAnnualReviewCode,
      data
    );
    return {
      data: (response.data || null) as AnnualReviewResponse,
      error: response.data ? null : errMsgNoData(),
    };
  } catch (error) {
    return {
      data: null,
      error: errMsg(error),
    };
  }
};

interface UserStatus {
  name: string;
  userId: string;
  designation: string;
  tier: string;
  mentorFeedbackStatus: string;
  userReviewId: string | null;
  reviewCreated: boolean;
}
export interface AnnualReviewUserStatus {
  data: UserStatus[];
  error: ErrorResponseType | null;
}

export const getAnnualReviewUserStatus = async (
  cycleId: string,
  mode: 'hr' | 'mentor'
): Promise<AnnualReviewUserStatus> => {
  try {
    const response = await axios.get(
      `${apiPaths.annualReviewUserStatus}/${cycleId}?mode=${mode}&code=${getAnnualReviewUserStatusCode}`
    );

    return {
      data: (response.data || null) as AnnualReviewUserStatus['data'],
      error: response.data ? null : errMsgNoData(),
    };
  } catch (error) {
    return {
      data: [],
      error: errMsg(error),
    };
  }
};

export const updateAnnualReviewByHr = async (
  cycleId: string,
  menteeId: string,
  data: AnnualReviewRequest
): Promise<AnnualReviewResponse> => {
  try {
    const response = await axios.put(
      `${apiPaths.annualReview}/hr-update/${cycleId}/${menteeId}?code=${updateAnnualReviewHrCode}`,
      data
    );
    return {
      data: (response.data || null) as AnnualReviewResponse,
      error: response.data ? null : errMsgNoData(),
    };
  } catch (error) {
    return {
      data: null,
      error: errMsg(error),
    };
  }
};
